import { useState, useEffect, useRef, useMemo } from "react";
import * as THREE from "three";
import { useFrame, useThree } from "@react-three/fiber";
import { Text, Html } from "@react-three/drei";
import { useTimer } from "use-timer";
import gsap from "gsap";
import SceneOne from "./Background-scene/SceneOne";
import { getRenderer } from "./WebGLRendererSingleton";

const LevelOne = ({
  // worldPosition,
  letter,
  letterImg,
  objectImg,
  nameImg,
  name,
  music,
  wordMusic,
  nextClick,
  setNextClick,
  wordCount,
}) => {
  const ref = useRef();
  const [spriteScale, setSpriteScale] = useState([0, 0, 0]);
  const [letterScale, setLetterScale] = useState([0, 0, 0]);
  const [intersectedObj, setIntersectedObj] = useState([]);
  const [effectActive, setEffectActive] = useState(false);
  const [objectGifVisible, setObjectGifVisible] = useState(false);
  const [objectGifPosition, setObjectGifPosition] = useState([]);
  const { time, start, pause, reset, status } = useTimer();

  const [worldPosition, setWorldPosition] = useState();

  // const { camera, gl } = useThree();
  const width = window.innerWidth;
  const height = window.innerHeight;
  const aspect = width / height;
  var camera = new THREE.OrthographicCamera();
  camera.aspect = width / height;

  const fov = 50;
  const planeAspectRatio = 16 / 9;

  const viewSize = 50;

  const loader = new THREE.TextureLoader();
  // A png with transparency to use as the target sprite.
  const textureA = useMemo(() => loader.load(letterImg), [letterImg]);
  // const textureA = loader.load(letterImg);
  textureA.colorSpace = THREE.SRGBColorSpace;
  textureA.minFilter = THREE.LinearFilter;
  textureA.wrapS = textureA.wrapT = THREE.RepeatWrapping;

  const objectTexture = useMemo(() => loader.load(objectImg), [objectImg]);
  // const objectTexture = loader.load(objectImg ? objectImg : letterImg);
  objectTexture.colorSpace = THREE.SRGBColorSpace;
  objectTexture.minFilter = THREE.LinearFilter;

  const nameTexture = useMemo(() => loader.load(nameImg), [nameImg]);
  // const nameTexture = loader.load(nameImg ? nameImg : letterImg);
  nameTexture.colorSpace = THREE.SRGBColorSpace;
  nameTexture.minFilter = THREE.LinearFilter;

  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();

  const { viewport: v, gl, scene } = useThree();

  var listener = new THREE.AudioListener();
  listener.current = new THREE.AudioListener();

  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  camera.add(listener);

  var sound = new THREE.Audio(listener);
  sound.autoplay = true;

  const [audioLoader, setAudioLoader] = useState(new THREE.AudioLoader());

  const audioContextRef = useRef(null);
  const audioBufferRef = useRef(null);
  const audioContextt = new (window.AudioContext ||
    window.webkitAudioContext)();

  const [renderers, setrenderers] = useState([]);

  function createRenderer() {
    if (renderers.length === 0) {
      const rendererr = getRenderer();

      setrenderers((prev) => [...prev, rendererr]);
      return rendererr;
    }
  }

  let renderer;
  if (renderers.length === 0) {
    renderer = createRenderer();
  }

  renderer?.domElement?.addEventListener("webglcontextlost", (event) => {
    console.log("WebGL context lost", gl.info.memory);

    textureA.dispose();
    objectTexture.dispose();
    objectTexture.dispose();
    clearTexture();
    setTimeout(() => {
      renderer?.forceContextRestore();
    }, 1000);
    // Handle context lost situation here
  });

  // Listen for context restored event
  renderer?.domElement?.addEventListener("webglcontextrestored", (event) => {
    console.log("WebGL context restored");

    // Resources should be reloaded or recreated here
  });

  useEffect(() => {
    audioContextRef.current = audioContextt;
  }, []);

  const audioPlay = async (data) => {
    if (sound.isPlaying) {
      sound.stop();
      sound.pause();
    }
    audioLoader.load(`${data}`, function (buffer) {
      sound.setBuffer(buffer);
      //sound.resume()
      sound.stop();
      sound.setLoop(true);
      sound.setVolume(1);
      sound.play();
      setTimeout(() => {
        sound.stop();
      }, buffer.duration * 1000);
    });
  };

  useFrame(({ clock, state }) => {
    if (effectActive) {
      const elapsedTime = clock.getElapsedTime();
      const scaleFactor = Math.sin(elapsedTime * 2) * 0.5 + 1.7;
      const stretchFactor = 1 / scaleFactor;
      //ref.current.children[0].scale.set(stretchFactor, scaleFactor, stretchFactor);
      ref.current.children[0].scale.x = stretchFactor;
      ref.current.children[0].scale.y = stretchFactor;
    } else {
      ref.current.children[0].scale.set(aspectWidth, aspectWidth, 1);
    }
  });

  function useAspect(width, height, factor = 0.12) {
    const adaptedHeight =
      height * (aspect > width / height ? v.width / width : v.height / height);
    const adaptedWidth =
      width * (aspect > width / height ? v.width / width : v.height / height);
    return [adaptedWidth * factor, adaptedHeight * factor, 1];
  }

  const [aspectWidth, aspectHeight] = useAspect(
    window.innerWidth,
    window.innerHeight
  );

  useEffect(() => {
    // adjustSpriteSize();
    // window.addEventListener("resize", function (e) {
    //   adjustSpriteSize();
    //   const height = window.innerHeight;
    //   const aspect = width / height;
    //   camera.aspect = window.innerWidth / window.innerHeight;
    //   if (camera.aspect > planeAspectRatio) {
    //     // window too large
    //     const cameraHeight = Math.tan(MathUtils.degToRad(fov / 2));
    //     const ratio = camera.aspect / planeAspectRatio;
    //     const newCameraHeight = cameraHeight / ratio;
    //     camera.fov = MathUtils.radToDeg(Math.atan(newCameraHeight)) * 2;
    //   } else {
    //     // window too narrow
    //     camera.fov = fov;
    //   }
    //   camera.updateProjectionMatrix();
    //   visibleWidthAtZDepth(camera.fov, camera);
    //   renderer?.setSize(width, height);
    // });
    return () => {
      objectTexture.dispose();
      nameTexture.dispose();
      textureA.dispose();

      scene.traverse(function (child) {
        if (child instanceof THREE.Mesh) {
          child.geometry.dispose();
          child.material.dispose();
        }
        if (child instanceof THREE.Sprite) {
          child.geometry.dispose();
          child.material.dispose();
        }
        if (child instanceof THREE.Group) {
          child.traverse(function (nestedChild) {
            if (nestedChild instanceof THREE.Mesh) {
              nestedChild.geometry.dispose();
              nestedChild.material.dispose();
            }
            if (nestedChild instanceof THREE.Sprite) {
              nestedChild.geometry.dispose();
              nestedChild.material.dispose();
            }
          });
        }
      });

      renderer?.dispose();
    };
  }, []);

  useEffect(() => {
    setEffectActive(false);
    // clearTexture()
    if (letter) {
      ref.current.children[0].visible = false;
      ref.current.children[1].visible = false;
      ref.current.children[2].visible = false;
      setObjectGifVisible(false);
      setTimeout(() => {

        if (ref.current && worldPosition) {
          ref.current.children[0].visible = true;
          ref.current.children[1].visible = false;
          ref.current.children[2].visible = false;
          setObjectGifVisible(false);

          arrangeObj();
        }
      }, 500);
    }
  }, [letter, worldPosition]);

  function onMouseClick(event, name) {
    if (sound.isPlaying) {
      sound.stop();
      sound.pause();
    }
    // Calculate mouse position in normalized device coordinates (-1 to +1)
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    // Update the picking ray with the camera and mouse position
    raycaster.setFromCamera(mouse, camera);

    // // Calculate objects intersecting the picking ray

    var vector = new THREE.Vector3(
      (event.clientX / window.innerWidth) * 2 - 1,
      -(event.clientY / window.innerHeight) * 2 + 1,
      0.5
    );
    var raycasterr = new THREE.Raycaster(
      camera.position,
      vector.sub(camera.position).normalize()
    );
    raycasterr.setFromCamera(vector, camera);

    // var intersectss = raycasterr.intersectObjects(intersectedObj, false);

    // alternative
    var intersectss = intersectedObj?.filter((itm) => itm.name === name);

    for (let i = 0; i < intersectss.length; i++) {
      const intersectedObject = intersectedObj[i];

      document.body.style.cursor = "pointer";
      // Perform any actions with the intersected object

      gsap.to(intersectedObject.scale, {
        x: intersectedObject.scale.x + aspect / 3,
        y: intersectedObject.scale.y + aspect / 3,
        onComplete: () => {
          gsap.to(intersectedObject.scale, {
            x: intersectedObject.scale.x - aspect / 3,
            y: intersectedObject.scale.y - aspect / 3,
            delay: 2,
            onComplete: () => { },
          });
        },
      });
    }
  }

  function adjustSpriteSize() {
    // Get the screen dimensions
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    // Define a base size for the sprite
    const baseWidth = 550; // Adjust this value as needed
    const baseHeight = 550; // Adjust this value as needed

    // Calculate the scale factors
    const scaleX = screenWidth / baseWidth;
    const scaleY = screenHeight / baseHeight;

    setSpriteScale([scaleX, scaleY, 0]);
  }

  const visibleHeightAtZDepth = (depth, camera) => {
    // compensate for cameras not positioned at z=0
    const cameraOffset = camera.position.z;
    if (depth < cameraOffset) depth -= cameraOffset;
    else depth += cameraOffset;

    // vertical fov in radians
    const vFOV = (camera.fov * Math.PI) / 180;

    // Math.abs to ensure the result is always positive
    return 2 * Math.tan(vFOV / 2) * Math.abs(depth);
  };

  const visibleWidthAtZDepth = (depth, camera) => {
    const height = visibleHeightAtZDepth(depth, camera);

    return height * camera.aspect;
  };

  function arrangeObj() {
    const positionLeft = worldPosition.left; // new THREE.Vector3({x: 1,y:0, z:0});
    // ref.current.children[3].getWorldPosition(position);
    const positionRight = worldPosition.right; // new THREE.Vector3({x: -1, y:0, z:0});
    ref.current.children[0].visible = true;

    // letter
    gsap.fromTo(
      ref.current.children[0].position,
      {
        y: 4, // 4,
        x: positionLeft.x + aspectWidth / 2.2, //+ ref.current.children[0].scale.x / 1.5, // positionLeft.x + aspect / 3 - 0.15,
        z: 1,
      },
      {
        y: 0,
        duration: 2,
        onComplete: () => {
          audioPlay(music);

          setTimeout(() => {
            // object
            ref.current.children[1].visible = true;
            ref.current.children[2].visible = true;
            setObjectGifVisible(true);
            setObjectGifPosition([
              positionRight.y + aspectWidth / 2,
              positionRight.x + aspect / 3.5,
              1,
            ]);
            if (letter === "T") {
              gsap.to(ref.current.children[2].scale, {
                x: aspectWidth * 1.5,
                y: aspectWidth * 1.5,
                z: 1,
              });
            } else {
              gsap.to(ref.current.children[2].scale, {
                x: aspectWidth,
                y: aspectWidth,
                z: 1,
              });
            }

            gsap.fromTo(
              ref.current.children[2].position,
              {
                y: 5,
                x: positionRight.x - aspectWidth / 4.7, //+ aspect/6, //width/height,
              },
              {
                y: positionRight.y + aspectWidth / 2, //ref.current.children[2].scale.y, //1,
                x: positionRight.x + aspect / 3.5,
                // y: positionRight.y + aspectWidth * 0.9, //ref.current.children[2].scale.y, //1,
                // x: positionRight.x - aspectWidth / 7, // + aspectWidth / 1.5, // + aspectWidth /1.2, //width/height,
                z: 1,
                duration: 1,
                onComplete: () => {
                  audioPlay(wordMusic);

                  gsap.to(ref.current.children[0].position, {
                    y: -4,
                    duration: 2,
                    delay: 3.5,
                    onComplete: () => {
                      textureA.map = null;
                      objectTexture.map = null;
                      nameTexture.map = null;
                      textureA.dispose();
                      objectTexture.dispose();
                      nameTexture.dispose();
                    },
                  });
                  gsap.to(ref.current.children[1].position, {
                    y: -4,
                    duration: 1.5,
                    delay: 3.5,
                  });
                  setObjectGifPosition([positionRight.x + aspect / 3.5, -4, 1]);
                  gsap.to(ref.current.children[2].position, {
                    y: -4,
                    duration: 2,
                    delay: 3.5,
                    onComplete: () => {
                      // ref.current.children[1].visible = false;
                      // ref.current.children[2].visible = false;
                      setTimeout(() => {
                        console.log(441166, nextClick)
                        if (nextClick < 2) {
                          renderer?.dispose();
                          setNextClick(nextClick + 1);
                        } else if (nextClick === 2) {
                          renderer?.dispose();
                          clearTexture();
                        }
                      }, 2000);
                    },
                  });
                },
              }
            );

            gsap.fromTo(
              ref.current.children[1].position,
              {
                y: 4,
              },
              {
                x: positionRight.x + aspect / 3, //- 0.2,
                y: positionRight.y - aspectWidth / 2, //ref.current.children[2].position.y,
                z: 1,
              }
            );
          }, 1000);
        },
      }
    );
    setIntersectedObj([ref.current.children[0]]);
  }

  const clearTexture = () => {
    scene.traverse(function (child) {
      if (child instanceof THREE.Mesh) {
        child.geometry.dispose();
        child.material.dispose();
      }
      if (child instanceof THREE.Sprite) {
        child.geometry.dispose();
        child.material.dispose();
      }
      if (child instanceof THREE.Group) {
        child.traverse(function (nestedChild) {
          // if (nestedChild instanceof THREE.Mesh) {
          //   nestedChild.geometry.dispose();
          //   nestedChild.material.dispose();
          // }
          // if (nestedChild instanceof THREE.Sprite) {
          //   nestedChild.geometry.dispose();
          //   nestedChild.material.dispose();
          // }
        });
      }
    });
  };

  return (
    <>
      <SceneOne level={1} setWorldPosition={setWorldPosition} />
      {letter && (
        <group ref={ref} dispose={null}>
          <mesh scale={[aspectWidth / 1.5, aspectWidth / 1.5, 1]} name={letter}>
            <sprite isSprite={true}>
              <spriteMaterial
                attach="material"
                map={textureA}
                precision={"lowp"}
              />
            </sprite>
          </mesh>
          <mesh
            scale={[
              wordCount === 3
                ? aspectWidth * 0.9
                : wordCount === 4
                  ? aspect * 1.1
                  : wordCount === 5
                    ? aspectWidth * 1.3
                    : wordCount === 6
                      ? aspectWidth * 1.6
                      : wordCount === 7
                        ? aspectWidth * 2
                        : wordCount === 8
                          ? aspectWidth * 2.1
                          : wordCount === 9
                            ? aspectWidth * 2
                            : wordCount === 10
                              ? aspectWidth * 2.1
                              : aspectWidth,
              wordCount === 3
                ? aspectWidth * 0.9
                : wordCount === 4
                  ? aspect * 1.1
                  : wordCount === 5
                    ? aspectWidth * 1.3
                    : wordCount === 6
                      ? aspectWidth * 1.6
                      : wordCount === 7
                        ? aspectWidth * 2
                        : wordCount === 8
                          ? aspectWidth * 2.1
                          : wordCount === 9
                            ? aspectWidth * 2
                            : wordCount === 10
                              ? aspectWidth * 2.1
                              : aspectWidth,
              1,
            ]}
          >
            <sprite isSprite={true}>
              <spriteMaterial
                map={nameTexture}
                precision={"lowp"}
                depthTest={false}
              />
            </sprite>
          </mesh>

          <mesh scale={[aspectWidth, aspectWidth, 1]}>
            <sprite isSprite={true}>
              <spriteMaterial
                attach="material"
                map={objectTexture}
                precision={"lowp"}
              />
            </sprite>
          </mesh>
        </group>
      )}
    </>
  );
};

function VideoMesh({ scale, position, objectImg, visible }) {
  const [pos, setPos] = useState(position);

  useEffect(() => {
    setPos(position);
  }, [visible, position]);

  return (
    <Html position={pos}>
      {visible && <img src={objectImg} width={200} height={200} />}
    </Html>
  );
}

export default LevelOne;
